<script setup lang="ts">
import type { CSSProperties } from 'vue'

export interface EImageProps {
  src?: string
  alt?: string
  width?: string | number
  height?: string | number
  style?: CSSProperties
}

const props = defineProps<EImageProps>()

const imgStyle = computed(
  (): CSSProperties => ({
    display: 'block',
    outline: 'none',
    border: 'none',
    textDecoration: 'none',
    ...props.style
  })
)
</script>

<template>
  <img :src="src" :alt="alt" :width="width" :height="height" :style="imgStyle" />
</template>
